'use client';

import Link from 'next/link';
import { HOST_HELP_FEED_CARD_BODY, HOST_HELP_FEED_CARD_TITLE, parseGrowthFocus } from '@communio/host-growth-guide';
import { useIsCommunityHost } from '@/platform/auth/useIsCommunityHost';
import { isCommunioShellBuild } from '@/config/brand';
import { isOpsItsmBuild } from '@/platform/servicedesk/isOpsItsmBuild';
import { useEffect, useState } from 'react';
import { ApiError } from '@/platform/lib/api';
import { fetchHostGuide } from './hostGuideApi';

const enabled = isCommunioShellBuild() && !isOpsItsmBuild();

/** Host-only feed card until a growth focus is saved. */
export function HostHelpFeedCard() {
  const { ready, isHost } = useIsCommunityHost(enabled);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!enabled || !ready || !isHost) {
      setShow(false);
      return;
    }
    let cancelled = false;
    void fetchHostGuide()
      .then((snap) => {
        if (cancelled) return;
        setShow(!parseGrowthFocus(snap.growthFocus));
      })
      .catch((e) => {
        if (cancelled) return;
        if (e instanceof ApiError && e.status === 403) {
          setShow(false);
          return;
        }
        setShow(true);
      });
    return () => {
      cancelled = true;
    };
  }, [isHost, ready]);

  if (!show) return null;

  return (
    <aside className="feed-card" data-testid="host-help-feed-card">
      <h2>{HOST_HELP_FEED_CARD_TITLE}</h2>
      <p className="text-muted">{HOST_HELP_FEED_CARD_BODY}</p>
      <p>
        <Link href="/help/" className="btn btn-primary">
          Open Help
        </Link>
      </p>
    </aside>
  );
}
